function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57 112.6a56.6 56.6 0 0 0 56.8-56.3A56.6 56.6 0 0 0 57 0 56.6 56.6 0 0 0 0 56.3 56.6 56.6 0 0 0 57 112.6Z",
  fill: "#FFE5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M113.6 84.4H64.9c-2.1 0-3.9 1.7-3.9 3.9V120c0 2.2 1.8 3.9 4 3.9h48.6c2.1 0 3.9-1.7 3.9-3.9V88.3c0-2.2-1.8-3.9-4-3.9Z",
  fill: "#CCC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M111.7 124v-17.6c0-.4-.3-.8-.6-.8H96.7c-.4 0-.7.4-.7.8V124h15.7Z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M90.3 90.2v-5.8h-8.9v5.8a4.4 4.4 0 0 0 2.8 4.1 4.5 4.5 0 0 0 4.7-.7c.8-.8 1.3-1.7 1.4-2.8v-.6Z",
  fill: "#999"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M113.6 20.9H64.9c-2.1 0-3.9 1.7-3.9 3.8v31.9c0 2.1 1.8 3.8 4 3.8h48.6c2.1 0 3.9-1.7 3.9-3.8V24.7c0-2.1-1.8-3.8-4-3.8Z",
  fill: "#EB6D6D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M111.7 60.4V43c0-.5-.3-.9-.6-.9H96.7c-.4 0-.7.4-.7.9v17.5h15.7Z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M90.3 26.7v-5.8h-8.9v5.8a4.4 4.4 0 0 0 2.8 4 4.5 4.5 0 0 0 4.7-.7c.8-.7 1.3-1.7 1.4-2.8v-.5Z",
  fill: "#333",
  fillOpacity: 0.2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M114.2 60.6H65.6c-2.2 0-3.9 1.7-3.9 3.9v16.1c0 2.2 1.7 3.9 3.9 3.9h48.6c2.2 0 4-1.7 4-3.9V64.5c0-2.2-1.8-4-4-4Z",
  fill: "#E6E6E6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M82.2 84.5V66.9c0-.4-.3-.8-.7-.8H67c-.4 0-.7.4-.7.8v17.6h15.8Z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M97.3 66.4v-5.8h-8.9v5.8a4.4 4.4 0 0 0 2.8 4.1 4.5 4.5 0 0 0 4.6-.8 4.2 4.2 0 0 0 1.5-3.3Z",
  fill: "#CCC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M32 40A631 631 0 0 1 2 42.3a56.3 56.3 0 0 0-.7 24.9l2.6.1c3.4 0 11-.5 31-2.6a12.7 12.7 0 0 0 10.7-9 12.4 12.4 0 0 0-4.2-13.2c-2.6-2-6-3-9.3-2.7Z",
  fill: "#15C0E8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M57 60.3c0 6.5-10.1 11.5-23 11.5-12.8 0-23.2-6.9-23.2-15.3 0-8.5 10.4-15.3 23.2-15.3 12.9 0 23 10.6 23 19Z",
  fill: "#15C0E8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m36 45.3-22.6 31L23 81l29.3-29.6c1.4-1.4 3.6-2.3 5.5-1.6l9.9 3.3a3.7 3.7 0 0 0 4.2-1.5l3.6-5.2a3.6 3.6 0 0 0-1.3-5.2l-19.9-11C38.7 23 43.3 37.8 36 45.2Z",
  fill: "#0E3163"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M48.8 68.6c-2 0-4.3-.4-7-1.2-2.3-.7-4.6-1.6-6.8-2.6a3.7 3.7 0 0 1-2.1-3.4 3.6 3.6 0 0 1 2.4-3.2 3.7 3.7 0 0 1 2.8 0c1.8.9 3.6 1.6 5.5 2.2 3.5 1 5.4 1 6 .9V61c0-1 .3-2 .9-2.7a3.7 3.7 0 0 1 6.4 1.9c.5 4-1.5 6-2.7 6.9a9 9 0 0 1-5.4 1.5Z",
  fill: "#15C0E8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M44 75.3a10 10 0 0 1-5.3-1.8c-3.4-2.2-10-5.2-10-5.3a3.6 3.6 0 0 1-1.9-4.8 3.6 3.6 0 0 1 5-1.7c.2.1 7 3.3 10.9 5.7.9.6 1.4.6 1.4.6.2 0 .6-.6.8-1l7 2.3c-.2.4-1.6 4.3-5.4 5.6-.7.2-1.6.4-2.4.4Z",
  fill: "#15C0E8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m34.9 79-1-.1c-2.3-.3-4.4-1.5-6.3-3.6-.8-.8-1.5-1.8-2-2.8l6.3-3.5c.6 1 2 2.6 3 2.7.3 0 1-.5 1.2-.7a3.7 3.7 0 0 1 6.2 2.5c0 1-.3 1.9-1 2.5a8.9 8.9 0 0 1-6.4 3ZM48.3 68.7a5.2 5.2 0 0 1-4.6-2.9 22.4 22.4 0 0 0-8.6-8 42.4 42.4 0 0 0-11.5-4.7 5.2 5.2 0 0 1-4-4.2 5 5 0 0 1 2.4-5.1 5.2 5.2 0 0 1 3.9-.7 53 53 0 0 1 14.5 6c4.2 2.5 9.7 6.6 12.5 12.2a5 5 0 0 1-2.3 6.8c-.7.4-1.5.6-2.3.6Z",
  fill: "#15C0E8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4 60.3c10.3 3 11.5-4.7 15.2-3.5 0 0 4-2.3-4.4-4.4-8.5-2-8.1-1.4-8.1-1.4l-2.7 9.3Z",
  fill: "#15C0E8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4 67.8h-.1a40 40 0 0 1-9-5.5.3.3 0 0 1 .3-.4.3.3 0 0 1 .3 0 39.4 39.4 0 0 0 8.8 5.4.3.3 0 0 1-.1.4h-.2ZM39 75c-2.4-.6-4.1-2.3-5.8-4L33 71c-1.7-1.7-3.5-3.4-5.7-3a.3.3 0 0 1-.3-.3.3.3 0 0 1 .2-.4c2.5-.4 4.4 1.4 6.2 3.2l.2.2c1.6 1.6 3.3 3.2 5.5 3.8a.3.3 0 0 1 .2.3.3.3 0 0 1-.1.3H39Z",
  fill: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3 68c-2.8 0-4.7-2.2-6.8-4.7-2.1-2.4-4.5-5-8-6.2-1.3-.4-2.2.3-3.5 1.3-2.1 1.7-5.1 4-11.7 2.2a.3.3 0 0 1-.2-.3.3.3 0 0 1 .2-.3h.2c6.3 1.7 9-.4 11.1-2 1.4-1.1 2.5-2 4-1.5 3.8 1.2 6.2 4 8.4 6.4 2.3 2.6 4.2 4.9 7.3 4.3 1.8-.4 3.1-1.3 3.7-2.7.6-1.6.3-3.7-.9-5.4A32.1 32.1 0 0 0 48 55a.3.3 0 0 1 .6-.2s1 1 3 4a6.4 6.4 0 0 1 1 6c-.5 1-1.6 2.5-4.2 3l-1.1.1Z",
  fill: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m22 87.3-8.8-6a2.6 2.6 0 0 1-.7-3.8l3.6-4.7 10.3 8.4a2.6 2.6 0 0 1 1 2.7c0 .3-.2.7-.4 1l-1.2 1.8a2.7 2.7 0 0 1-3.7.6Z",
  fill: "#0E3163"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 50H98v7.3h.7v-7.4ZM100.5 50h-.7v7.3h.7v-7.4ZM102.4 50h-.7v7.3h.7v-7.4ZM104.2 50h-.6v7.3h.6v-7.4ZM106.1 50h-.7v7.3h.7v-7.4ZM108 50h-.7v7.3h.7v-7.4ZM109.8 50h-.6v7.3h.6v-7.4ZM69 75.3h-.6v7.4h.7v-7.4ZM71 75.3h-.7v7.4h.6v-7.4ZM72.8 75.3H72v7.4h.7v-7.4ZM74.7 75.3H74v7.4h.7v-7.4ZM76.5 75.3H76v7.4h.6v-7.4ZM78.4 75.3h-.7v7.4h.7v-7.4ZM80.2 75.3h-.6v7.4h.6v-7.4ZM98.7 114.8H98v7.4h.7v-7.4ZM100.5 114.8h-.7v7.4h.7v-7.4ZM102.4 114.8h-.7v7.4h.7v-7.4ZM104.2 114.8h-.6v7.4h.6v-7.4ZM106.1 114.8h-.7v7.4h.7v-7.4ZM108 114.8h-.7v7.4h.7v-7.4ZM109.8 114.8h-.6v7.4h.6v-7.4Z",
  fill: "#000"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M108.2 54.3H88.5a.7.7 0 0 1-.6-.4.7.7 0 0 1 .2-.7l.4-.2h19.7c.1 0 .3 0 .4.2a.7.7 0 0 1-.4 1.1Z",
  fill: "#CC2E66"
});

function SvgBipError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = React.forwardRef(SvgBipError);
export default __webpack_public_path__ + "static/media/bip-error.b5b2b486.svg";
export { ForwardRef as ReactComponent };